export default __webpack_public_path__ + "static/media/client-15.3c9bb621.png";